import { render, staticRenderFns } from "./wrestler_full_info_collector.vue?vue&type=template&id=334f41b6&"
import script from "./wrestler_full_info_collector.vue?vue&type=script&lang=js&"
export * from "./wrestler_full_info_collector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports